module.exports = __webpack_public_path__ + "img/logo-ar.93082da9.webp";